function formatMobile() {
  return function(number) {
    if (number) {
      let phoneNumber = number
        .split("")
        .map(function(char, index) {
          if (4 > index || index > 7) {
            return char;
          } else {
            return "*";
          }
        })
        .join("");
      return phoneNumber;
    }
  };
}

module.exports = ngModule => {
  ngModule.filter("formatMobile", formatMobile);
};
